/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useEffect, useRef, useState } from "react";
import Close from "../../../images/Close.svg";
import { Title } from "../../../stories/Title/Title";
import ParticularTicketDetails from "./common/ParticularTicketDetails";
import Gallery from "../../../images/DownloadImage.svg";
import {
  convertToTimeZone,
  ticketStatusMobileClassName,
  toIsoDate,
} from "../../../utils/UtilFunctions";
import Webcam from "react-webcam";
import Camera from "../../../images/Followup Icons/Camera.svg";
import mic from "../../../images/Followup Icons/Voice.svg";
import { payloadTypes } from "../../../context/reducer";
import { AppContext } from "../../../context/context";
import { GetTransformTicketDetailsForFollowUp } from "./queries/queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddTransformTicketDetailsResult,
  AddTransformTicketDetailsVar,
  GetTransformTicketDetailsForFollowUpResult,
  GetTransformTicketDetailsForFollowUpVar,
} from "./queries/types";
import {
  EMPTY_STRING,
  TicketStatus,
  emptyMessage,
} from "../../../utils/constants";
import { AtsTicketDetails } from "../asset/maps/queries/types";
import { Operation, TimeZone } from "../../../utils/Enum.types";
import MessageModal from "../../../customComponents/MessageModal";
import { AddTransformTicketDetails } from "./queries/mutations";
import useServerDateandTimeWithoutToken from "../../../customHooks/useServerDateandTimeWithoutToken";
import { handleUploadAndDownloadFile } from "../../../utils/Upload";
import { getDownloadUrl } from "../../../utils/DownloadFile";
import { Button } from "../../../stories/Button/Button";
import LoadingModal from "../../pages/LoadingModal";
import { CustomDrawerInMobile } from "../../../styles/CustomDrawerStyles";
import DocumentsDownload from "../../../images/DocumentsDownload.svg";

interface ticketDetailsList extends AtsTicketDetails {
  flag: boolean;
  image: string;
}
interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const FollowUpStatus = ({ setModal }: Props) => {
  const webcamRef = useRef<Webcam | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [imageData, setImageData] = useState<{
    filename: string;
    url: string;
  }>({ filename: "", url: "" });
  const [imageModal, setImageModal] = useState(false);
  const [audioURL, setAudioURL] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const [ticketDetails, setTicketDetails] = useState<ticketDetailsList[]>([]);
  const [message, setMessage] = useState(emptyMessage);
  const [ticketStatus, setTicketStatus] = useState(TicketStatus.ALL);
  const [mutationCompleted, setMutationCompleted] = useState(false);
  const [file, setFile] = useState<FileList | null>(null);
  const [remark, setRemark] = useState("");
  const [progress, setProgress] = useState(0);

  const { serverDate } = useServerDateandTimeWithoutToken();

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const [getTransformTicketDetailsForFollowUp, { data: followUpData }] =
    useLazyQuery<
      GetTransformTicketDetailsForFollowUpResult,
      GetTransformTicketDetailsForFollowUpVar
    >(GetTransformTicketDetailsForFollowUp);

  const [addTransformTicketDetails, { data: addData, loading }] = useMutation<
    AddTransformTicketDetailsResult,
    AddTransformTicketDetailsVar
  >(AddTransformTicketDetails, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  // Capture Photo
  const handlePhotoClick = () => {
    setShowCamera(true);

    setTimeout(() => {
      if (webcamRef.current) {
        const image = webcamRef.current.getScreenshot();

        if (image) {
          setImageSrc(image);
        }
      }
      setShowCamera(false);
    }, 500);
  };

  // Start Voice Recording
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      const chunks: Blob[] = [];
      mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setAudioURL(url);
      };

      mediaRecorder.start();
      setIsRecording(true);
    } catch (err) {
      console.error("Permission denied or device not available", err);
      alert("Please allow microphone access to record your voice.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  useEffect(() => {
    if (state.customerId && state.junctionID) {
      getTransformTicketDetailsForFollowUp({
        variables: {
          customerID: state.customerId,
          junctionID: state.junctionID,
          ticketID: state.ticketId ? state.ticketId : 0,
        },
      }).then(({ data }) => {
        if (data && data.GetTransformTicketDetails) {
          const updateData = data.GetTransformTicketDetails.map((ticket) => {
            return {
              ...ticket,
              flag: false,
              image: EMPTY_STRING,
            };
          });

          setTicketDetails(updateData);
        }
      });
    }
  }, [
    getTransformTicketDetailsForFollowUp,
    state.companyId,
    followUpData,
    state.ticketId,
  ]);

  const handleSubmit = (status: TicketStatus) => {
    setMutationCompleted(true);

    const ext = file?.[0].name.split(".").pop();
    let filename = "";

    if (state.companyId)
      filename = file
        ? `${state.companyId}/ticketDetails/${file?.[0].name}.${ext}`
        : "";

    if (state.ticketId && state.customerId && state.companyId) {
      addTransformTicketDetails({
        variables: {
          customerID: state.customerId,
          ticketID: state.ticketId,
          todaysDate: toIsoDate(serverDate),
          input: {
            imagesPath: filename,
            remarks: remark,
            status,
          },
        },
        refetchQueries: [
          {
            query: GetTransformTicketDetailsForFollowUp,
            variables: {
              customerID: state.customerId,
              junctionID: state.junctionID,
              ticketID: state.ticketId ? state.ticketId : 0,
            },
          },
        ],
      }).then(async ({ data }) => {
        if (data && data.AddTransformTicketDetails) {
          if (file && file[0]) {
            const ext = file[0].name.split(".").pop();
            const awsFilename = `${data.AddTransformTicketDetails.companyID}/ticketDetails/${data.AddTransformTicketDetails.id}_0.${ext}`;
            const uploadFilePromise = await handleUploadAndDownloadFile(
              file[0],
              awsFilename,
              setProgress,
              false
            );
            if (uploadFilePromise) {
              setFile(null);
              setMessage({
                flag: true,
                message: "Ticket updated successfully",
                operation: Operation.CREATE,
              });
              setMutationCompleted(false);
            } else {
              setMessage({
                flag: true,
                message: "File upload failed",
                operation: Operation.NONE,
              });
              setMutationCompleted(false);
            }
          } else {
            setFile(null);
            setMessage({
              flag: true,
              message: "Ticket updated successfully",
              operation: Operation.CREATE,
            });
            setMutationCompleted(false);
          }
        }
      });
    }
  };

  const handleClose = () => {
    setRemark("");
    setFile(null);
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  return (
    <div className="mobile-followup">
      <div className="mobile-followup__title">
        <Title variant="subtitle2"> Ticket Details</Title>
        <img
          src={Close}
          alt=""
          onClick={() => {
            setModal(false);
            dispatch({
              type: payloadTypes.SET_TICKET,
              payload: {
                ticketId: 0,
              },
            });
          }}
        />
      </div>
      <div className="mobile-followup__block">
        <div className="mobile-followup__block--ticket-details">
          <ParticularTicketDetails setTicketStatus={setTicketStatus} />
        </div>

        <div className="mobile-followup__block--follow-up">
          <div className="mobile-followup__block--follow-up--flex">
            <b>Follow Up Status</b>
            <span className="font-amber">
              {followUpData?.GetTransformTicketDetails.length}
            </span>
          </div>
          <div className="mobile-followup__block--follow-up--search">
            <input
              type="text"
              value={remark}
              placeholder="Type here"
              onChange={(e) => {
                setRemark(e.target.value);
              }}
              className="text-light"
            />
            <div className="mobile-followup__block--follow-up--search--flex">
              {/* {showCamera && (
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  className="rounded shadow"
                />
              )} */}

              <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => {
                  setFile(e.target.files);
                }}
                style={{ display: "none" }}
                accept="jpg, .png, .jpeg"
                capture="environment"
              />
              <button
                onClick={() => {
                  handleButtonClick();
                }}
              >
                <img src={Camera} alt="Capture Photo" />
              </button>

              {imageSrc && <img src={imageSrc} alt="Captured" />}

              {/* {!isRecording ? (
                <button onClick={startRecording}>
                  <img src={mic} alt="" />{" "}
                </button>
              ) : (
                <button onClick={stopRecording}>
                  <img src={mic} alt="" />{" "}
                </button>
              )} */}

              {audioURL && <audio controls src={audioURL} />}
            </div>
          </div>
          <div className="mobile-followup__block--follow-up--buttons">
            {ticketStatus === TicketStatus.RESOLVED ? (
              <>
                <Button
                  className="mobile-followup__block--follow-up--buttons--re-open"
                  disabled={!remark || loading || mutationCompleted}
                  onClick={() => handleSubmit(TicketStatus.RE_OPENED)}
                >
                  Re-open Ticket
                </Button>
                <Button
                  className="mobile-followup__block--follow-up--buttons--close"
                  disabled={!remark || loading || mutationCompleted}
                  onClick={() => handleSubmit(TicketStatus.CLOSED)}
                >
                  Close Ticket
                </Button>
              </>
            ) : null}

            <Button
              className="mobile-followup__block--follow-up--buttons--update"
              disabled={!remark || loading || mutationCompleted}
              onClick={() => handleSubmit(ticketStatus as TicketStatus)}
            >
              Update
            </Button>
          </div>
          <div className="mobile-followup__block--follow-up--remarks">
            <ul>
              {ticketDetails
                ? ticketDetails.map((res, index) => {
                    return (
                      <li key={index}>
                        <b>{res.remarks}</b>
                        <div className="mobile-followup__block--follow-up--remarks--flex">
                          <span
                            className={ticketStatusMobileClassName(res.status)}
                          >
                            {res.status}
                          </span>

                          {res.imagesPath ? (
                            <>
                              <div
                                className="mobile-followup__block--follow-up--remarks--flex--image"
                                onClick={async () => {
                                  try {
                                    setMutationCompleted(true);
                                    const ext = res.imagesPath.split(".").pop();
                                    const filename = `${res.companyID}/ticketDetails/${res.id}_0.${ext}`;
                                    const ers = await getDownloadUrl(
                                      filename,
                                      false
                                    );
                                    setImageData({
                                      filename: filename,
                                      url: ers,
                                    });
                                    setImageModal(true);
                                    setMutationCompleted(false);
                                  } catch (error) {
                                    setMutationCompleted(false);
                                    setMessage({
                                      flag: true,
                                      message: "Failed to fetch image",
                                      operation: Operation.NONE,
                                    });
                                  }
                                }}
                              >
                                <img src={Gallery} alt="" />
                                <b>1</b>
                              </div>
                            </>
                          ) : null}
                        </div>
                        <span className="mobile-followup__block--follow-up--remarks--date">
                          {
                            convertToTimeZone(
                              TimeZone.Asia_Kolkata,
                              res.attendedDate
                            ).date
                          }
                          {"  "}
                          {
                            convertToTimeZone(
                              TimeZone.Asia_Kolkata,
                              res.attendedDate
                            ).time
                          }
                        </span>
                      </li>
                    );
                  })
                : ""}
            </ul>
          </div>
        </div>
      </div>

      <CustomDrawerInMobile
        anchor="bottom"
        open={imageModal}
        onClose={() => setImageModal(!imageModal)}
      >
        <div className="mobile-followup">
          <div className="mobile-followup__title">
            <img
              src={Close}
              alt=""
              onClick={() => {
                setImageModal(false);
              }}
            />
          </div>

          <div className="view-image">
            <div className="download-icon">
              <img
                src={DocumentsDownload}
                alt=""
                onClick={async () => {
                  try {
                    setMutationCompleted(true);
                    const ers = await getDownloadUrl(imageData.filename, true);
                   
                    setMutationCompleted(false);
                  } catch (error) {
                    setMutationCompleted(false);
                    setMessage({
                      flag: true,
                      message: "Failed to fetch image",
                      operation: Operation.NONE,
                    });
                  }
                }}
              />
            </div>
            <img src={imageData.url ? imageData.url : Gallery} />
          </div>
        </div>
      </CustomDrawerInMobile>
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      <LoadingModal
        flag={loading || mutationCompleted}
        message="Fetching..."
        forMobile={true}
      />
    </div>
  );
};

export default FollowUpStatus;
